import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformServer} from '@angular/common';
import {ActivatedRouteSnapshot, CanMatch, Route, Router, RouterStateSnapshot, UrlSegment} from '@angular/router';
import { Observable } from 'rxjs';
import {TokenDataProviderService} from '../services/token-data-provider.service';

@Injectable({
    providedIn: 'root'
})
export class NoAuthGuard implements CanMatch  {

  constructor(
    private router: Router,
    private ts: TokenDataProviderService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.isLoggedIn()) {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }

  canMatch(route: Route, segments: UrlSegment[]): boolean {
    return !this.isLoggedIn();
  }

  private isLoggedIn(): boolean {
    if (isPlatformServer(this.platformId)) {
      return this.ts.isLoggedInSSR();
    }

    return this.ts.isLoggedIn();
  }
}
